export default __webpack_public_path__ + "static/Fall4-01ceda0e99acecd998b401b43bff052b.mp3";